import OverdueDataStatistics from './OverdueDataStatistics';

const OverdueAmountStatistics: React.FC = () => (
  <OverdueDataStatistics metric="amount" title="逾期资损统计" />
);

export default OverdueAmountStatistics;
